import { RecordData } from "./utility.type";

export const hasRecordValue = <T extends Partial<RecordData<any>>>(data: T) => {
  if (!data) return false;
  const values = Object.values(data);
  for (const value of values) {
    if (typeof value === 'string') {
      if (value) return true;
    } else {
      if (value !== undefined) return true;
    }
  }
  return false;
}